import axios from "axios";

// Global guard: never surface raw Cloudflare/HTML error pages to POG'Rs.
const FRIENDLY = "AIR.POG hit a bump — please try again in a moment.";

axios.interceptors.response.use(
  (r) => r,
  (error) => {
    const d = error?.response?.data;
    if (typeof d === "string" || (d && typeof d.detail !== "string" && typeof d !== "object")) {
      error.response.data = { detail: FRIENDLY };
    } else if (typeof d?.detail === "string" && /cloudflare|origin web server|<html/i.test(d.detail)) {
      error.response.data = { detail: FRIENDLY };
    }
    return Promise.reject(error);
  }
);
